<div *ngIf="isDisplayed"><strong>Výměra</strong><br/>
<div [loading]="loading"><div *ngIf="!loading">
       <label>V pořádku:</label> <div *ngIf="toKeep > 0" class="{{classToKeep}} info">{{ toKeep|number }}&nbsp;m<sup>2</sup></div><div *ngIf="toKeep === 0" class="info">-</div><br/>
       <label>Nadbytečná:</label> <div *ngIf="toSell > 0" class="{{classToSell}} info">{{ toSell|number }}&nbsp;m<sup>2</sup></div><div *ngIf="toSell === 0" class="info">-</div><br/>
       <label>Pro výkup:</label> <div *ngIf="toBuy > 0" class="{{classToBuy}} info">{{ toBuy|number }}&nbsp;m<sup>2</sup></div><div *ngIf="toBuy === 0" class="info">-</div><br/>
  </div></div>
</div>
